import { Dispatch, SetStateAction } from 'react';
import { useDispatch } from 'react-redux';
import { AnyAction } from 'redux';
import { StoreDispatch, Thunk } from '@/redux/types';

export const useThunkActionWithLoadingState = <T extends Array<any>, V>(
  actionCreator: (...args: T) => Thunk<Promise<V>, AnyAction>,
  loadingStateSetter: Dispatch<SetStateAction<boolean>>
) => {
  const dispatch = useDispatch<StoreDispatch>();

  return (...args: T) => {
    loadingStateSetter(true);

    return dispatch(actionCreator(...args)).then(
      (result) => {
        loadingStateSetter(false);
        return result;
      },
      (error) => {
        loadingStateSetter(false);
        throw error;
      }
    );
  };
};
